import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import Hero from "../components/hero";
import ConnectionPage from "../pages/ConnectionPage";
import CurrencyPages from "../pages/Currency";
import SeriesPage from "../pages/SeriesPage";
import TexturesPage from "../pages/Textures";
import SupplierPage from "./../pages/SupplierPage";
import UnitPage from "./../pages/UnitPage";
import InsertsPage from "../pages/InsertsPage";
import FillingPage from "../pages/FillingPage";
import AccessoriesPage from "../pages/AccessoriesPage";
import ProfileSystemPage from "../pages/ProfileSystemPage";
import UserPage from "../pages/UserPage";
import ExchangePages from "../pages/Exchange";
import ProfilePage from "../pages/product/ProfilePage";
import AccessoriesTypePage from "../pages/product/AccessoriesTypePage";
import SealTypePage from "../pages/product/SealTypePage";
import FillingTypePage from "../pages/product/FillingTypePage";
import TextureGroupPage from "../pages/TextureGroupPage";
import Feedback from "../pages/feedback";
import TempletesPage from "../pages/Templetes";
import MobileUserPage from "../pages/MobileUserPage";
import SalesCategoryPage from "../pages/SalesCategoryPage";
import MaterialTypePage from "../pages/MaterialTypePage";
import Templates from "../pages/Templates";
import CountryPage from "../pages/CountryPage";
import WorkshopServicePage from "../pages/WorkshopServicePage";
import PriceRequestPage from "../pages/PriceRequestPage";
import AppVersionPage from "../pages/AppVersionPage";
import TranslationPage from "../pages/TranslationPage";
import LanguagePage from "../pages/LanguagePage";
import TariffFeaturePage from "../pages/TariffFeaturePage";
import AkfaIntegrationPage from "../pages/AkfaIntegrationPage";
import AkfaUnitMappingPage from "../pages/AkfaUnitMappingPage";

const MainRoutes = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Hero />} />
        <Route path="/currency/*" element={<CurrencyPages />} />
        <Route path="/exchange/*" element={<ExchangePages />} />
        <Route path="country/*" element={<CountryPage />} />
        <Route path="/user/*" element={<UserPage />} />
        <Route path="/suppliers/*" element={<SupplierPage />} />
        <Route path="/textures/*" element={<TexturesPage />} />
        <Route path="/templetes/*" element={<TempletesPage />} />
        <Route path="/texturegroup/*" element={<TextureGroupPage />} />
        <Route path="/units/*" element={<UnitPage />} />
        <Route path="/connection/*" element={<ConnectionPage />} />
        <Route path="/series/*" element={<SeriesPage />} />
        <Route path="/material-type/*" element={<MaterialTypePage />} />
        <Route path="/templates/*" element={<Templates />} />
        <Route path="/inserts/*" element={<InsertsPage />} />
        <Route path="/filling/*" element={<FillingPage />} />
        <Route path="/furniture/*" element={<AccessoriesPage />} />
        <Route path="/profile_system/*" element={<ProfileSystemPage />} />
        <Route path="/product/profile/*" element={<ProfilePage />} />
        <Route
          path="/product/accessories/*"
          element={<AccessoriesTypePage />}
        />
        <Route path="/product/seal/*" element={<SealTypePage />} />
        <Route path="/product/filling/*" element={<FillingTypePage />} />
        <Route path="feedback" element={<Feedback />} />
        <Route path="/mobile_user/*" element={<MobileUserPage />} />
        <Route path="/sales_category/*" element={<SalesCategoryPage />} />
        <Route path="/workshop-service/*" element={<WorkshopServicePage />} />
        <Route path="/price-requests/*" element={<PriceRequestPage />} />
        <Route path="/app-versions/*" element={<AppVersionPage />} />
        <Route path="/translations/*" element={<TranslationPage />} />
        <Route path="/languages/*" element={<LanguagePage />} />
        <Route path="/tariff-feature/*" element={<TariffFeaturePage />} />
        <Route path="/integrations/akfa/*" element={<AkfaIntegrationPage />} />
        <Route path="/integrations/unit/*" element={<AkfaUnitMappingPage />} />
      </Routes>
    </>
  );
};

export default MainRoutes;
